import { isMemberOfBoard } from './isMemberOfBoard';

/**
 * True when a `board` is public and `idMember` is not one of its
 * members (i.e. the viewer can only see this board *because* it is public).
 *
 * `idMember` is `null` for a logged-out viewer
 *
 * This assumes the board was fully read. Missing memberships or preferences
 * could result in an inaccurate result.
 */
export const isPublicBoardNonMember = <
  TInputBoard extends {
    memberships: { idMember: string }[] | null;
    prefs: { permissionLevel?: string | null } | null;
  },
>(
  board: TInputBoard | null | undefined,
  idMember: string | null,
): boolean => {
  if (board?.prefs?.permissionLevel !== 'public') {
    return false;
  }

  return idMember ? !isMemberOfBoard(board, idMember) : true;
};
